module.exports = __webpack_public_path__ + "img/1.a59ad89c.png";